import instanceQuery from 'graphql/queries/supplier/PurchaseInvoiceTransactionQuery.graphql';
import fragment from 'graphql/fragments/nominal/PostedTransactionsFragment.graphql';

const PurchaseInvoiceTransactions = {
  type: 'PostedTransactionsResponse',
  formTitle: 'Posted Transactions',
  instance: instanceQuery,
  fragment,
};

export default PurchaseInvoiceTransactions;
